const initialState = {
  accessKey: '',
  partNumberData: {},
  sellerPartId: ''
};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ACCESS_KEY':
      return { ...state, accessKey: action.payload };
    case 'RESET_ACCESS_KEY':
      return { ...state, accessKey: '' };
    case 'UPDATE_PART_NUMBER':
      return { ...state, partNumberData: action.payload };
    case 'PART_NUMBER_DATA':
      return {
        ...state,
        sellerPartId: action?.payload?.sellerPartId
      };
    case 'RESET_PART_NUMBER_DATA':
      return { ...state, sellerPartId: '' };
    default:
      return state;
  }
};

export default SettingsReducer;
